// 0- 等待上传 1-正在上传 2-上传失败 3-上传完成

import {
	uploadFile2OSS
} from "@/utils/OSSUpload"

import {
	v4 as uuidv4
} from 'uuid';

var uploadList = []
var uploadCallback

/**
 * 设置上传进度监听，用于界面刷新
 * @param {Object} callback
 */
export function setUploadCallback(callback) {
	uploadCallback = null
	// console.log('--------------- setUploadCallback')
	uploadCallback = callback
}

/**
 * 移除上传进度监听
 */
export function removeUploadCallback() {
	uploadCallback = null
}

/**
 * 获取上传列表
 */
export function getUploadList() {
	// console.log("getUploadList " + uploadList.length)
	return uploadList
}

/**
 * 取消上传
 * @param {Object} uploadInfo
 */
export function cancelUpload(uploadInfo) {
	uploadInfo.status = 0
	uploadInfo.client.cancel()
}

/**
 * 重新上传
 * @param {Object} uploadInfo
 */
export async function resumeUpload(uploadInfo) {
	return await startUpload(uploadInfo)
}

// /**
//  * 停止上传
//  * @param {Object} uploadInfo
//  */
// function stopUpload(uploadInfo){

// }

/**
 * 添加任务到上传列表
 * @param {Object} uploadInfo
 */
export async function addTask(uploadInfo, checkFileFormatCallback) {
	uploadList.push(uploadInfo)
	let res = await startUpload(uploadInfo, checkFileFormatCallback)

}

/**
 * 开始上传
 * @param {Object} uploadInfo
 */
async function startUpload(uploadInfo, checkFileFormatCallback) {
	// console.log("add task " + uploadList.length)
	uploadInfo.uuid = uuidv4()
	uploadInfo.status = 0;
	let res = await uploadFile2OSS(uploadInfo.ossInfo, uploadInfo.file, uploadInfo.filePath, (p, cp, res) => {
		// console.log("uploadFile2OSS callback");
		uploadInfo.status = 1;
		uploadInfo.process = p;
		if (uploadCallback != null) {
			uploadCallback(p, cp, res)
		}
	}, (client) => {
		uploadInfo.client = client
	}, (status) => {
		if (checkFileFormatCallback != null) {
			checkFileFormatCallback(status)
		}
	})
	if (res.status !== 0) {
		uploadInfo.status = 2;
		uploadInfo.remarks = res.msg
	} else {
		uploadInfo.status = 3;
	}
	if (res.status === 0) {
		if (uploadInfo.finishCallback !== null) {
			await uploadInfo.finishCallback(uploadInfo)
			//更新界面
			if (uploadCallback != null) {
				uploadCallback(1, null, null)
			}
		}
	}
	return res
}

/**
 * 删除上传任务
 * @param {Object} uploadInfo
 */
export function removeTask(uploadInfo) {
	cancelUpload(uploadInfo)
	let index = -1;

	for (var i = 0; i < 3; i++) {
		if (uploadList[i].uuid === uploadInfo.uuid) {
			index = i
			break
		}
	}
	if (index >= 0) {
		uploadList.splice(index, 1)
	}
}
